import ServiceTemplate from '@/components/ServiceTemplate';

export default function CopyrightPortfolio() {
  const data = {
    title: 'Copyright Portfolio Management',
    subtitle: 'Professional management and optimization of copyright portfolios.',
    overviewTitle: 'Managing Your Copyright Portfolio',
    overviewImage: 'https://images.unsplash.com/photo-1664575602554-2087b04935a5',
    description: [
      'Copyright portfolio management involves strategic oversight of multiple copyrighted works, including registrations, renewals, licensing, enforcement, and monetization. Effective management maximizes portfolio value.',
      'Our portfolio management service provides comprehensive oversight of your creative works, ensuring proper protection, identifying monetization opportunities, and maintaining organized records.',
      'We help creators, publishers, and content owners build valuable copyright portfolios that generate revenue while protecting against infringement.'
    ],
    benefits: [
      { title: 'Centralized Management', description: 'Single point of oversight for all copyrights.' },
      { title: 'Registration Coordination', description: 'Manage registrations across multiple works.' },
      { title: 'Revenue Optimization', description: 'Identify and maximize licensing opportunities.' },
      { title: 'Enforcement Monitoring', description: 'Proactive monitoring for infringement.' },
      { title: 'Strategic Planning', description: 'Long-term portfolio development strategy.' },
      { title: 'Organized Records', description: 'Maintain comprehensive copyright records.' }
    ],
    process: [
      { title: 'Setup & Configuration', description: 'Initial assessment and configuration of monitoring parameters tailored to your needs.' },
      { title: 'Continuous Monitoring & Analysis', description: 'Ongoing surveillance and expert analysis of findings with actionable intelligence.' },
      { title: 'Action & Protection', description: 'Strategic guidance and implementation of protection measures when threats are identified.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Single work registration',
        price: '$199',
        period: '+ filing fees ($45-$65)',
        features: [
          'Single work registration',
          'Copyright Office filing',
          'Application preparation',
          'Certificate delivery',
          'Email support',
          'Standard processing'
        ]
      },
      {
        name: 'Professional',
        description: 'Multi-work package',
        price: '$399',
        period: '+ filing fees',
        featured: true,
        features: [
          'Up to 5 works registration',
          'Expedited filing available',
          'Comprehensive documentation',
          'Priority processing',
          'Copyright monitoring (6 months)',
          'Phone support',
          'Enforcement consultation'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Portfolio management',
        price: '$799',
        period: '+ filing fees',
        features: [
          'Unlimited registrations',
          'Portfolio strategy planning',
          'Ongoing monitoring',
          'DMCA takedown services',
          'Infringement detection',
          'Legal representation',
          'Dedicated account manager'
        ]
      }
    ],
    faqs: [
      { question: 'What works should be in my portfolio?', answer: 'Include all original creative works: written content, artwork, photographs, software, music, videos, and other copyrightable creations.' },
      { question: 'Should I register everything?', answer: 'Prioritize registration for valuable works, those you may need to enforce, or works for licensing. Strategic registration balances protection with costs.' },
      { question: 'How do you monitor for infringement?', answer: 'We use technology tools and services to monitor online use, plus manual review of key markets and competitors.' },
      { question: 'Can you manage international portfolios?', answer: 'Yes, we manage copyright portfolios across multiple jurisdictions, coordinating registrations and enforcement internationally.' },
      { question: 'What about orphaned works?', answer: 'We help identify ownership gaps, update records, and ensure continuous protection for works with unclear or changing ownership.' },
      { question: 'How do you identify licensing opportunities?', answer: 'Through market analysis, industry contacts, and strategic outreach to potential licensees in relevant markets.' },
      { question: 'What records should be maintained?', answer: 'Maintain registration certificates, creation documentation, licensing agreements, assignment records, and enforcement actions for each work.' },
      { question: 'How often should portfolio be reviewed?', answer: 'Annual reviews are standard, with more frequent reviews for active licensing or high-value portfolios.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
